'use client';
import React, { useContext, useEffect, useState } from 'react';
import { signIn, useSession } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import PrimaryButton from '../../buttons/primary-button/PrimaryButton';
import PageLoaderContext from '@/app/_contexts/page-loader-context/PageLoaderContext';
import styles from './loginForm.module.scss';

type Props = {};

const LoginForm = (props: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const { setIsPageLoading } = useContext(PageLoaderContext);
  const { status } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (status === 'authenticated') {
      router.replace('/auth/login');
    }
  }, [status, router]);

  const loginHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsPageLoading(true);
    const res = await signIn('credentials', {
      ...formData,
      redirect: false,
      callbackUrl: '/auth/login'
    });

    if (res && !res.ok) {
      let parsedError;
      if (res.error) {
        parsedError = JSON.parse(res.error);
        setErrorMessage(parsedError);
        setIsPageLoading(false);
      } else {
        setErrorMessage(null);
        setIsPageLoading(false);
      }
    } else {
      setErrorMessage(null);

      setIsPageLoading(false);
    }
  };

  return (
    <form
      className={styles.loginForm}
      onSubmit={(e) => loginHandler(e)}
      method="POST"
    >
      <h3>Sign in to your account</h3>
      {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
      <div className={styles.formGroup}>
        <label
          className={errorMessage ? `${styles.error}` : ''}
          htmlFor="email"
        >
          Email
        </label>
        <input
          id="email"
          name="email"
          type="email"
          placeholder="example@mail.com"
          onChange={(e) => {
            setFormData({ ...formData, email: e.target.value });
          }}
        />
      </div>
      <div className={styles.formGroup}>
        <label
          className={errorMessage ? `${styles.error}` : ''}
          htmlFor="password"
        >
          Password
        </label>
        <input
          id="password"
          name="password"
          type="password"
          onChange={(e) => {
            setFormData({ ...formData, password: e.target.value });
          }}
        />
      </div>
      <PrimaryButton
        label="Login"
        type="submit"
        disabled={formData.email.length === 0 || formData.password.length === 0}
      />
    </form>
  );
};

export default LoginForm;
